import { ApiConceptRelation, ApiMultiConceptRelationResponse } from 'types/swagger/clarifai-api';
import { fetchApi } from 'utils/request';

export type ListConceptRelationsRequest = {
  userOrOrgId: string;
  appId: string;
  page?: number;
  perPage: number;
};

export const listConceptRelations = async ({
  userOrOrgId,
  appId,
  page = 1,
  perPage = 512,
}: ListConceptRelationsRequest): Promise<ApiConceptRelation[] | null> => {
  const response = await fetchApi<ApiMultiConceptRelationResponse>({
    path: `/api/_api/v2/users/${userOrOrgId}/apps/${appId}/concepts/relations?page=${page}&per_page=${perPage}`,
    method: 'GET',
  });
  // TODO: types/swagger/clarifai-api.ts has INVALID status.code, which is a STRING?? But BE returns a number!
  // Therefore a hack for it below (as unknown as number) :/
  if (response?.status?.code && (response.status.code as unknown as number) === 10000 && response?.concept_relations) {
    return response.concept_relations?.length ? response.concept_relations : ([] as ApiConceptRelation[]);
  }
  return null;
};
